import { Injectable } from '@angular/core';
import { Environment } from '../../config/environment';

/**
 * Sends the post-exam GET calls to myehe-aggregator-service instead of epms-proxy when
 * aggregator_enabled is "true" in environment.json.
 *
 * The aggregator sits behind API Gateway's /aggregator/{proxy+} resource (SigV4, same VPC Link
 * as /epmsproxy and /faq-assistant) and serves the same paths and bodies as epms-proxy. Only the
 * path prefix changes: /epmsproxy/api/... becomes <aggregator_base_url>/api/..., and the call
 * still goes through ApiGatewayService, so signing, X-auth-token and error handling are unchanged.
 */
@Injectable({
	providedIn: 'root',
})
export class AggregatorRouteService {
	private static readonly EPMS_PROXY_PREFIX = '/epmsproxy';
	/** The 15 post-exam GET paths the aggregator serves (after the /epmsproxy prefix, no query). */
	private static readonly POST_EXAM_PATHS =
		/^\/api\/(lab-results\/[^/]+|comparative-lab-results\/[^/]+|health-reports|health-report\/[^/]+|health-score\/(latest|history|biomarkers-content)|health-summary|health-documents(\/[^/]+)?|immunization|referrals(\/past-referrals)?)$/;

	constructor(private environment: Environment) {}

	/**
	 * The aggregator path for a post-exam GET when the flag is on, for example
	 * /epmsproxy/api/health-summary -> /aggregator/api/health-summary. Null for every other call.
	 */
	toAggregatorPath(requestUrl: string): string | null {
		const env = this.environment.getEnvironment();
		if (env.AGGREGATOR_ENABLED !== 'true' || !env.AGGREGATOR_BASE_URL || !requestUrl) {
			return null;
		}
		const prefix = AggregatorRouteService.EPMS_PROXY_PREFIX;
		const path = requestUrl.split('?')[0];
		if (!path.startsWith(prefix) || !AggregatorRouteService.POST_EXAM_PATHS.test(path.substring(prefix.length))) {
			return null;
		}
		return env.AGGREGATOR_BASE_URL + requestUrl.substring(prefix.length);
	}
}
